<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Others
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-text-field 
                                                label="Receive No" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="receive_no.value.value"
                                                :error-messages="receive_no.errorMessage.value"
                                                autocomplete="off"
                                                clearable>
                                                <template #label>
                                                    Receive No
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Customer Chalan No" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="chalan_no.value.value"
                                                :error-messages="chalan_no.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                            </v-text-field>

                                            <v-date-input 
                                                label="Receive Date" 
                                                density="compact" 
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="receive_date.value.value"
                                                :error-messages="receive_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable>
                                            </v-date-input>

                                            <!-- :items="getCustomerMapList.filter(item => item.customer.customer_type.name == 'Buyer')" -->
                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="customer_id.value.value"
                                                @update:model-value="onCustomerChange"
                                                :items="getCustomerMapList"
                                                :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"
                                                item-value="customer_id"
                                                :error-messages="customer_id.errorMessage.value"
                                                autocomplete="off" 
                                                clearable
                                                >
                                                <template #label>
                                                    Buyer Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field 
                                                label="Shop Name" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="shop_name.value.value"
                                                :error-messages="shop_name.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                                <template #label>
                                                    Shop Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Buyer Phone" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="buyer_phone.value.value"
                                                :error-messages="buyer_phone.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                            </v-text-field>

                                            <v-autocomplete 
                                                label="Shipment Mode" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="shipment_mode.value.value"
                                                :items="[{ name: 'by_sea', display_text: 'By Sea' }, { name: 'by_road', display_text: 'By Road' }, { name: 'by_air', display_text: 'By Air' }]"
                                                :item-title="(item) => `${item.display_text}`" 
                                                item-value="name"
                                                :error-messages="shipment_mode.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>

                                            <v-autocomplete 
                                                label="Mode Of Payment"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="payment_mode.value.value"
                                                :items="[{ name: 'freight_collect', display_text: 'Freight Collect' }, { name: 'freight_prepaid', display_text: 'Freight Prepaid' }]"
                                                :item-title="(item) => `${item.display_text}`" 
                                                item-value="name"
                                                :error-messages="payment_mode.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>

                                            <v-autocomplete 
                                                label="Port of Loading"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="from_port_id.value.value"
                                                @update:model-value="onFromPortChange"
                                                :items="getPortList"
                                                :item-title="(item) => `${item.name} - ${item.country?.emoji} ${item.country?.name}`" 
                                                item-value="id"
                                                :error-messages="from_port_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template v-slot:selection="{ props, item }">
                                                    <div class="d-flex align-center noto-color-emoji-regular"
                                                        v-bind="props"
                                                        color="primary"
                                                        variant="tonal"
                                                    >
                                                    {{ item.raw.name }}, 
                                                    {{ item.raw.country.name }}
                                                    <span class="noto-color-emoji-regular">{{ item.raw.country.emoji }}</span>
                                                    </div>
                                                </template>
                                                <template v-slot:item="{ props, item }">
                                                    <v-list-item v-bind="props" v-slot=""  :title="null">
                                                        <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                            <div class="flex-grow-1">
                                                                <span>{{ item.raw.name }}</span>
                                                            </div>
                                                            <div class="text-grey text-caption">
                                                                {{ item.raw.country.name }}
                                                                <span class="mr-2 text-lg noto-color-emoji-regular">{{ item.raw.country.emoji }}</span>
                                                            </div>
                                                        </div>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>

                                             <v-autocomplete 
                                                label="Port of Destination" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="to_port_id.value.value"
                                                @update:model-value="onToPortChange"
                                                :items="getPortList"
                                                :item-title="(item) => `${item.name} - ${item.country?.emoji} ${item.country?.name}`"
                                                item-value="id"
                                                :error-messages="to_port_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template v-slot:selection="{ props, item }">
                                                    <div class="d-flex align-center noto-color-emoji-regular"
                                                        v-bind="props"
                                                        color="primary"
                                                        variant="tonal"
                                                    >
                                                    {{ item.raw.name }}, 
                                                    {{ item.raw.country.name }}
                                                    <span class="mr-1 noto-color-emoji-regular">{{ item.raw.country.emoji }}</span>
                                                    </div>
                                                </template>
                                                <template v-slot:item="{ props, item }">
                                                    <v-list-item v-bind="props" v-slot=""  :title="null">
                                                        <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                            <div class="flex-grow-1">
                                                                <span>{{ item.raw.name }}</span>
                                                            </div>
                                                            <div class="text-grey text-caption">
                                                                {{ item.raw.country.name }}
                                                                <span class="mr-2 text-lg noto-color-emoji-regular">{{ item.raw.country.emoji }}</span>
                                                            </div>
                                                        </div>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field 
                                                label="Commodity" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="commodity.value.value"
                                                :error-messages="commodity.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                            </v-text-field>

                                             <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="supplier_id.value.value"
                                                @update:model-value="onSupplierChange"
                                                :items="getCustomerMapList"
                                                :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"
                                                item-value="customer_id"
                                                :error-messages="supplier_id.errorMessage.value"
                                                autocomplete="off" 
                                                clearable
                                                >
                                                <template #label>
                                                    Shipper Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <!-- <v-autocomplete 
                                                label="Shipper Name"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                :items="getSupplierMapList"
                                                @update:model-value="onSupplierChange"
                                                v-model="supplier_id.value.value"
                                                :item-title="item => item && item.supplier?.supplier_name && item.supplier?.code ? `${item.supplier.supplier_name} - ${item.supplier.code}` : ''"                                                  
                                                item-value="supplier_id"
                                                :error-messages="supplier_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete> -->

                                            <v-text-field 
                                                label="Shipper Company Name"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="shipper_company_name.value.value"
                                                :error-messages="shipper_company_name.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                                <template #label>
                                                    Shipper Company Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Shipper Phone"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="shipper_phone.value.value"
                                                :error-messages="shipper_phone.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-text-field>

                                            <v-autocomplete 
                                                label="Sales Order By"
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                :items="getBrandList"
                                                v-model="sales_by.value.value"
                                                :item-title="item => item && item.name"                                                  
                                                item-value="id"
                                                :error-messages="sales_by.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>

                                            <v-autocomplete 
                                                label="Currency"
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                :items="getLatestExchangeRateList"
                                                v-model="rate_id.value.value"
                                                :item-title="item => item && item.currency_name"                                                  
                                                item-value="id"
                                                :error-messages="rate_id.errorMessage.value"
                                                @update:model-value="onCurrencyChange"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>

                                            <v-text-field
                                                label="Currency Rate"
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="currency_rate.value.value"
                                                :error-messages="currency_rate.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" clearable>
                                            </v-text-field>

                                            <v-text-field
                                                label="Entry By"
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Entry Person Mobile"
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by_mobile.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true" 
                                                clearable>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    
                                    <v-row>
                                        <v-col>
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="min-height: 40vh;"
                                            >
                                            <thead>
                                                <tr>
                                                    <th style="width: 5%">SL</th>
                                                    <th style="min-width: 200px">PRODUCT NAME</th>
                                                    <th style="min-width: 150px">CATEGORY</th>
                                                    <th style="min-width: 150px">CALC TYPE</th>
                                                    <th style="min-width: 120px">CBM MEAS.</th>
                                                    <th style="min-width: 150px">CTN/BAG QTY/ KG</th>
                                                    <th style="min-width: 120px">PRODUCT QTY</th>
                                                    <th style="min-width: 120px">CBM</th>
                                                    <th style="min-width: 120px">RATE</th>
                                                    <th style="min-width: 150px">AMOUNT</th>
                                                    <th style="min-width: 200px">REMARKS</th>
                                                    <th style="min-width: 80px">ACTION</th>
                                                </tr>
                                                </thead>
                                                <tbody >
                                                    <tr v-for="(detail, index) in cart" :key="index">
                                                        <td class="text-center py-2">{{ index + 1 }}</td>
                                                        <td class="py-2">
                                                            <v-autocomplete
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.product_id"
                                                                :items="getProductMapList"
                                                                :item-title="(item) => `${item.product?.name}`"
                                                                item-value="product_id"
                                                                label="Product"
                                                                autocomplete="off"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'product_id')"
                                                                @blur="validateDetailField(index, 'product_id', detail.product_id)"
                                                                @update:search="onSearch"
                                                            >
                                                                <template #append-item>
                                                                    <v-list-item v-if="search && !productExists" @click="createNewProduct(search)">
                                                                        <v-list-item-title>
                                                                            ➕ Add "<strong>{{ search }}</strong>" as new product
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </td>

                                                        <td class="py-2">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'Brand', value:'brand'}, {title:'Non-Copy', value:'non_copy'}, {title:'Normal Copy', value:'normal_copy'}, {title:'Copy & Brand', value:'copy_and_brand'}]"
                                                                v-model="detail.category"
                                                                label="Category"
                                                                hide-details
                                                                autocomplete="off"
                                                                :error-messages="getDetailError(index, 'category')"
                                                                @blur="validateDetailField(index, 'category', detail.category)"
                                                            />
                                                        </td>

                                                         <td class="py-2" style="width: 160px">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'CBM', value:'cbm'}, {title:'Carton/Bag', value:'ctn'}, {title:'KG', value:'kg'}]"
                                                                v-model="detail.calc_type"
                                                                label="Calc"
                                                                autocomplete="off"
                                                                hide-details
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm_meas"
                                                                label="CBM MEAS."
                                                                width="120px"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'cbm_meas')"
                                                                @blur="validateDetailField(index, 'cbm_meas', detail.cbm_meas)"
                                                            />
                                                        </td>
                                                      
                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.bag"
                                                                type="number"
                                                                label="CTN/BAG QTY/KG"
                                                                width="150px"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'bag')"
                                                                @blur="validateDetailField(index, 'bag', detail.bag)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.qty"
                                                                label="QTY"
                                                                width="100px"
                                                                autocomplete="off"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'qty')"
                                                                @blur="validateDetailField(index, 'qty', detail.qty)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm"
                                                                label="CBM"
                                                                width="120px"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'cbm')"
                                                                @blur="validateDetailField(index, 'cbm', detail.cbm)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.rate"
                                                                label="Rate"
                                                                width="120px"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'rate')"
                                                                @blur="validateDetailField(index, 'rate', detail.rate)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.total"
                                                                label="Amount"
                                                                width="120px"
                                                                hide-details
                                                                readonly
                                                                :error-messages="getDetailError(index, 'total')"
                                                                @blur="validateDetailField(index, 'total', detail.total)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.remarks"
                                                                label="Remarks"
                                                                width="200px"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'Total')"
                                                                @blur="validateDetailField(index, 'Total', detail.total)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-icon
                                                                @click="removeDetailRow(index)"
                                                                color="red"
                                                                icon="mdi-minus"
                                                                size="medium"
                                                                class="btn"
                                                            ></v-icon>
                                                            
                                                            <v-icon
                                                                @click="addDetailRow"
                                                                v-if="index == cart.length - 1"
                                                                color="info"
                                                                icon="mdi-plus"
                                                                size="medium"
                                                                class="ml-2"
                                                            ></v-icon>  
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>

                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">
                                                 <tfoot>
                                                    <tr>
                                                        <th colspan="3"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Sub Total
                                                        </th>

                                                        <th colspan="3" class="bg-grey-lighten-1"></th>

                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(subTotal) }}
                                                        </th>

                                                        <th colspan="2" class="bg-grey-lighten-1"></th>

                                                    </tr>

                                                    <tr>
                                                        <td colspan="3" class="text-right">
                                                            Discount (10 or 10%)
                                                        </td>

                                                        <td></td>
                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="discount_value.value.value"
                                                                density="compact" 
                                                                label="%" 
                                                                hide-details 
                                                                dense
                                                                autocomplete="off" 
                                                                variant="outlined" 
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(discountAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3" class="text-right py-1">
                                                            Tax (10 or 10%)
                                                        </td>

                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-select 
                                                                v-model="taxType" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                :items="includeOrExclude"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                hide-details
                                                                style="width: 115px">
                                                            </v-select>
                                                        </td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field v-model="tax_value.value.value"
                                                                density="compact" label="%" hide-details dense
                                                                autocomplete="off" variant="outlined" />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(taxAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="3" class="text-right py-1">
                                                            Vat (10 or 10%)
                                                        </td>
                                                        <td></td>
                                                        <td colspan="1" class="text-right py-1">
                                                            <v-select 
                                                                v-model="vatType" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                :items="includeOrExclude"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                hide-details
                                                                style="max-width: 115px">
                                                            </v-select>
                                                        </td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="vat_value.value.value"
                                                                density="compact" 
                                                                label="%" hide-details dense
                                                                autocomplete="off" 
                                                                variant="outlined" 
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(vatAmount) }}
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <th colspan="3"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Grand Total
                                                        </th>
                                                        <th colspan="3" class="bg-grey-lighten-1 text-right py-1"></th>
                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(grandTotal) }}
                                                        </th>
                                                        <th class="bg-grey-lighten-1"></th>
                                                    </tr>
                                                </tfoot>
                                            </v-table>
                                        </v-col>
                                    </v-row>

                                    <v-divider></v-divider>
                                    <v-row class="pt-0">
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <v-card-title
                                                    class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5"
                                                    style="font-size: 1.1rem;">
                                                    <span class="">Payment</span>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text>
                                                     <v-row>
                                                        <v-col cols="5" sm="5" md="5">
                                                            Payment Method
                                                        </v-col>
                                                        <v-col cols="7" sm="7" md="7">
                                                            <v-select 
                                                                v-model="payment_method.value.value" 
                                                                :items="paymentTypes"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details="auto"
                                                                :error-messages="payment_method.errorMessage.value"
                                                                autocomplete="off"
                                                            >
                                                            </v-select>
                                                            
                                                        </v-col>
                                                        <v-col cols="5" sm="5" md="5">
                                                            Payment Head
                                                        </v-col>
                                                        <v-col cols="7" sm="7" md="7">
                                                            <v-autocomplete
                                                                v-model="payment_acc_account_head_id.value.value"
                                                                :items="getPaymentAccountHeadList"
                                                                :item-title="(item) => `${item.name ?? 'Select'}`"
                                                                item-value="id"
                                                                variant="outlined"
                                                                density="compact"
                                                                hide-details="auto"
                                                                autocomplete="off"
                                                                clearable
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque No
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                density="compact"
                                                                v-model="cheque_no.value.value" 
                                                                variant="outlined" 
                                                                hide-details
                                                                autocomplete="off" />
                                                            </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque Date
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-date-input 
                                                                density="compact"
                                                                prepend-icon="" 
                                                                prepend-inner-icon="mdi-calendar"
                                                                v-model="cheque_date.value.value" 
                                                                variant="outlined"
                                                                hide-details 
                                                                autocomplete="off"
                                                            ></v-date-input>
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Bank Name
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_bank_name.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Branch Name
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_branch_name.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Account No
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_bank_account_no.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="5" sm="5" md="5">
                                                            Provider
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="7" sm="7" md="7">
                                                            <v-autocomplete 
                                                                v-model="mobileProvider"
                                                                :items="mobileProviders" 
                                                                item-title="label"
                                                                item-value="value" 
                                                                density="compact" 
                                                                variant="outlined"
                                                                hide-details 
                                                                autocomplete="off"
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="5" sm="5" md="5">
                                                            Transaction ID
                                                        </v-col>

                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="7" sm="7" md="7">
                                                            <v-text-field v-model="transactionId" density="compact"
                                                                variant="outlined" hide-details autocomplete="off" />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Advance Payment
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="paid.value.value" 
                                                                density="compact"
                                                                label="Payment Received" 
                                                                type="number" 
                                                                hide-details
                                                                variant="outlined"
                                                                @update:model-value="onChangePayReceived" 
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Previous Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="previous_due.value.value" 
                                                                density="compact"
                                                                label="Previous Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" 
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Total Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="due.value.value" 
                                                                density="compact"
                                                                label="Total Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Date
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-date-input 
                                                                label="Next Payment Date" 
                                                                density="compact" 
                                                                prepend-icon=""
                                                                prepend-inner-icon="mdi-calendar" 
                                                                variant="outlined"
                                                                v-model="next_payment_date.value.value"
                                                                :error-messages="next_payment_date.errorMessage.value"
                                                                autocomplete="off"
                                                                clearable>
                                                            </v-date-input>
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Approx. Amount
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="next_payment_amount.value.value" density="compact"
                                                                type="number" hide-details variant="outlined" />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>

                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea label="Description" density="compact" variant="outlined"
                                                    bg-color="grey-lighten-4" v-model="remarks.value.value"
                                                    :error-messages="remarks.errorMessage.value" autocomplete="off"
                                                    rows="3" clearable></v-textarea>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <v-btn class="bg-grey-darken-1 me-2" variant="flat"
                                                        @click="submitForm(0)">DRAFT</v-btn>
                                                    <v-btn class="bg-primary" variant="flat"
                                                        @click="submitForm(1)">POST</v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, getCurrentInstance, ref, reactive, computed } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import axios from "axios";
import { baseURL } from "@/store/api";

export default {
    components: {},
    data: () => ({
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
        vatType: 'include',
        taxType: 'include',
        includeOrExclude: [
            { value: 'include', label: "Include" },
            { value: 'exclude', label: "Exclude" },
        ],
        bankName: null,
        accountNo: "",
        mobileProvider: null,
        transactionId: "",
        paymentTypes: [
            { label: "Cash", value: "cash" },
            { label: "Bank", value: "bank" },
            { label: "Mobile Banking", value: "mobile" }
        ],
        banks: [
            { label: "Al Rajhi Bank", value: "alrajhi" },
            { label: "NCB", value: "ncb" },
            { label: "Riyad Bank", value: "riyad" }
        ],
        mobileProviders: [
            { label: "Bkash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
        ]
    }),
    watch: {
        grandTotal(newVal) {
            this.due.value.value = (parseFloat(newVal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
        "payment_method.value.value":{
            handler(newVal){
                if (newVal) {
                    this.$store.dispatch("getPaymentAccountHeadList", {
                        type: newVal,
                    }).then((res) => {
                        console.log(res);
                    });
                    this.payment_acc_account_head_id.value.value = null;
                }
            }
        }
    },
    created() {
        if (this.$store.getters.getBrandList.length === 0) {
            this.$store.dispatch("getBrandList");
        }
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
        if (this.$store.getters.getSupplierMapList.length === 0) {
            this.$store.dispatch("getSupplierMapList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }

        if(this.$store.getters.getHrmDepartmentList.length === 0) {this.$store.dispatch('getHrmDepartmentList');}

        if(this.$store.getters.getPortList.length === 0) {this.$store.dispatch('getPortList');}

        if (this.$store.getters.getLatestExchangeRateList.length == 0) {this.$store.dispatch('getLatestExchangeRateList')}

    },
    computed: {
        subTotal() {
            return this.cart.reduce((sum, item) => +sum + +item.total, 0);
        },

        discountAmount() {
            if (!this.discount_value?.value.value) {
                this.discount_value.value.value = 0;
                this.discount_method.value.value = 'flat';
                return 0;
            } 

            const val = this.discount_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.discount_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        taxAmount() {
            if (!this.tax_value?.value.value) {
                this.tax_value.value.value = 0;
                this.tax_method.value.value = 'flat';
                return 0;
            } 

            const val = this.tax_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.tax_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        vatAmount() {
            if (!this.vat_value.value.value) {
                this.vat_value.value.value = 0;
                this.vat_method.value.value = 'flat';
                return 0;
            } 

            const val = this.vat_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.vat_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        grandTotal() {
            const discount = this.discountAmount;
            const vat = this.vatType === 'include' ? this.vatAmount : 0;
            const tax = this.taxType === 'include' ? this.taxAmount : 0;
            return this.subTotal + vat + tax - discount;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },

        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        getSupplierMapList() {
            return this.$store.getters.getSupplierMapList;
        },
        getPortList() {
            return this.$store.getters.getPortList;
        },
        getBrandList() {
            return this.$store.getters.getBrandList;
        },
        getPaymentAccountHeadList() {
            return this.$store.getters.getPaymentAccountHeadList;
        },
        getLatestExchangeRateList() {
            const rates = this.$store.getters.getLatestExchangeRateList || [];
            return rates.map(rate => ({
                ...rate,
                currency_name: rate.currency ? `${rate.currency.symbol} ${rate.currency.name} (${rate.currency.code})` : 'N/A'
            }));
        },
        filteredWorkOrderList() {
            const workorders = this.$store.getters.getSalesWorkOrderList || [];
            return workorders.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
    },
    methods: {
        onChangePayReceived() {
            this.due.value.value = (parseFloat(this.grandTotal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
       
        async onCustomerChange(id) {
            if (!id) {
                this.shop_name.value.value = "";
                this.buyer_phone.value.value = "";
                return;
            }

            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

            if (customer) {
                this.shop_name.value.value = customer.customer_owner_name || "";
                this.buyer_phone.value.value = customer.mobile || customer.customer_mobile || customer.customer_phone || customer.phone || "";
            } else {
                this.shop_name.value.value = "";
                this.buyer_phone.value.value = "";
            }
            
        },

        async onSupplierChange(id) {
            if (!id) {
                this.shipper_company_name.value.value = "";
                this.shipper_phone.value.value = "";
                return;
            }

            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

            if(customer) {
                this.shipper_company_name.value.value = customer.customer_owner_name || "";
                this.shipper_phone.value.value = customer.mobile || customer.customer_mobile || customer.customer_phone || customer.phone || "";
            } else {
                this.shipper_company_name.value.value = "";
                this.shipper_phone.value.value = "";
            }

            // const list = this.$store.getters.getSupplierMapList || [];
            // let entry = list.find((it) => {
            //     return it.supplier_id == id || (it.supplier && (it.supplier.id == id || it.supplier.supplier_id == id));
            // });

            // let supplier = entry ? entry.supplier : null;

            // if (!supplier) {
            //     try {
            //         supplier = await this.$store.dispatch("getSupplierById", id);
            //     } catch (err) {
            //         supplier = null;
            //     }
            // }

            // if (supplier) {
            //     this.shipper_company_name.value.value = supplier.company_name || supplier.company_owner_name || "";
            //     this.shipper_phone.value.value = supplier.supplier_mobile || supplier.company_mobile || supplier.company_phone || supplier.phone || "";
            // } else {
            //     this.shipper_company_name.value.value = "";
            //     this.shipper_phone.value.value = "";
            // }
        },
        onCurrencyChange(id) {
            const list = this.$store.getters.getLatestExchangeRateList || [];
            let currency = list.find((it) => {
                return it.id == id;
            });
            if(currency) {
                this.currency_rate.value.value = currency.rate || "";

            } else {
                this.currency_rate.value.value = "";
            }
        },
        onFromPortChange(val) {
            try { this.from_port_id.value.value = val; } catch (e) {}
            const toVal = this.to_port_id?.value?.value;
            if (val && toVal && val === toVal) {
                try { this.to_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Loading and Port of Destination cannot be the same — destination cleared.");
            }
        },

        onToPortChange(val) {
            try { this.to_port_id.value.value = val; } catch (e) {}
            const fromVal = this.from_port_id?.value?.value;
            if (val && fromVal && val === fromVal) {
                try { this.from_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Destination and Port of Loading cannot be the same — loading cleared.");
            }
        },
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                receive_no: yup.string().required().label('Receive no'),
                chalan_no: yup.string().nullable().label('Chalan no'),
                receive_date: yup.date().required().label("Receive Date"),
                customer_id: yup.number().positive().integer().required().label("Buyer Name"),
                shop_name: yup.string().required().label("Shop Name"),
                supplier_id: yup.number().positive().integer().required().label("Shipper Name"),
                shipper_company_name: yup.string().required().label("Shipper Company Name"),
                shipment_mode: yup.string().nullable().label("Shipment Mode"),
                payment_mode: yup.string().nullable().label('Payment Mode'),
                payment_method: yup.string().nullable().label('Payment Method'),
                from_port_id: yup.string().nullable().label('Port of Loading'),
                to_port_id: yup.string().nullable().label('Port of Destination').test(
                    'not-same-port',
                    'Port of Destination must be different from Port of Loading',
                    function(value) {
                        const from = this.parent?.from_port_id;
                        if (!value || !from) return true; // no comparison if one is empty
                        return value !== from;
                    }
                ),
                sales_by: yup.number().positive().integer().required().label("Sales By"),
                rate_id: yup.number().positive().integer().required().label("Exchange Rate"),
            }),
        });

        const product_id = useField("product_id");
        const sale_order_master_id = useField("sale_order_master_id");
        const employee_id = useField("employee_id");
        const customer_id = useField("customer_id");
        const payment_mode = useField("payment_mode");
        
        const from_port_id = useField("from_port_id");
        const to_port_id = useField("to_port_id");
        
        const receive_no = useField("receive_no");    
        const chalan_no = useField("chalan_no");
        const receive_date = useField("receive_date");
        const shop_name = useField("shop_name");
        const buyer_phone = useField("buyer_phone");
        const shipment_mode = useField("shipment_mode");
        
        const commodity = useField("commodity");
        
        const supplier_id = useField("supplier_id");
        const shipper_company_name = useField("shipper_company_name");
        const shipper_phone = useField("shipper_phone");

        const sales_by = useField("sales_by");
        
        const discount_value = useField("discount_value");
        const discount_method = useField("discount_method");
        const discount_amount = useField("discount_amount");
        const tax_amount = useField("tax_amount");
        const tax_value = useField("tax_value");
        const tax_type = useField("tax_type");
        const tax_method = useField("tax_method");
        const vat_amount = useField("vat_amount");
        const vat_value = useField("vat_value");
        const vat_type = useField("vat_type");
        const vat_method = useField("vat_method");
        
        const rate_id = useField("rate_id");
        const currency_rate = useField("currency_rate");

        const payment_method = useField("payment_method");
        const payment_acc_account_head_id = useField("payment_acc_account_head_id");
        const cheque_no = useField("cheque_no");
        const cheque_date = useField("cheque_date");
        const issuing_bank_name = useField("issuing_bank_name");
        const issuing_branch_name = useField("issuing_branch_name");
        const issuing_bank_account_no = useField("issuing_bank_account_no");

        const detailErrors = reactive({});
        const status = useField("status");

        const saleOrder_by = useField("saleOrder_by");
        const saleOrder_by_mobile = useField("saleOrder_by_mobile");
        const saleOrder_by_email = useField("saleOrder_by_email");
        const total = useField("total");
        const paid = useField('paid');
        const next_payment_date = useField('next_payment_date');
        const next_payment_amount = useField('next_payment_amount');
        const previous_due = useField('previous_due');
        const due = useField('due');
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const cart = ref([
            {
                product_id: null,
                calc_type: null,
                category: null,
                bag: "",
                qty: "",
                length: "",
                width: "",
                height: "",
                cbm_meas: "",
                cbm: "",
                rate: "",
                total: "",
                remarks: "",
            },
        ]);

        const addDetailRow = () => {
            cart.value.push({
                product_id: null,
                calc_type: null,
                category: null,
                bag: "",
                qty: "",
                length: "",
                width: "",
                height: "",
                cbm_meas: "",
                cbm: "",
                rate: "",
                total: "",
                remarks: "",
            });
        };

        const removeDetailRow = (index) => {
            if (cart.value.length > 1) {
                cart.value.splice(index, 1);
                delete detailErrors[index];
                const newErrors = {};
                Object.keys(detailErrors).forEach((key) => {
                const idx = parseInt(key);
                if (idx > index) {
                    newErrors[idx - 1] = detailErrors[key];
                } else if (idx < index) {
                    newErrors[idx] = detailErrors[key];
                }
                });
                Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
                Object.assign(detailErrors, newErrors);
            }
        };


        const search = ref("");
        const productExists = computed(() => {
            // return customerOptions.value.some(
            //     (c) => c.name.toLowerCase() === search.value.toLowerCase()
            // );
        });

        // Handle search text
        function onSearch(val) {
            search.value = val;
        };

        function calculateRow(row) {
            const bag = Number(row.bag) || 0;
            // const qty = Number(row.qty) || 0;
            const rate = Number(row.rate) || 0;

            // const L = Number(row.length) / 100 || 0;
            // const W = Number(row.width) / 100 || 0;
            // const H = Number(row.height) / 100 || 0;

            if (row.calc_type === "cbm") {
                // row.cbm_meas = (L * W * H).toFixed(4);
                row.cbm = (row.cbm_meas * bag).toFixed(3);
                row.total = (row.cbm * rate).toFixed(2);
            }

            if (row.calc_type === "ctn") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (bag * rate).toFixed(2);
            }

            if (row.calc_type === "kg") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (bag * rate).toFixed(2);
            }
        };

        async function createNewProduct(name) {
            loading.value = true;
            
            await axios.post(baseURL + "/api/auth/inventory/save-update-product", { name }).then((res) => {
                if (res.data.success) {
                    toast.success(res.data.message);
                    loading.value = true;
                    store.dispatch('getProductMapList')
                        .then(data => {
                            loading.value = false;
                        })
                        .catch(error => {
                            loading.value = false;
                            toast.error(error.response.data.message);   
                        })
                } else {
                    toast.error(res.data.message || "Failed to create product");
                }   
            }).catch((error) => {
                toast.error(error.response.data.message || "Failed to create product");
            });

            loading.value = false;
        }

        const loading = ref("");
        const buttonText = ref("");

        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const validateDetailField = (index, field, value) => {
                if (!detailErrors[index]) {
                    detailErrors[index] = {};
                }

                detailErrors[index][field] = "";

                switch (field) {
                     case "product_id":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Product must be needed";
                        } else {
                            const duplicate = cart.value.some((detail, idx) => idx !== index && detail.product_id == value);
                            if (duplicate) {
                            detailErrors[index][field] = "Product must be unique";
                            }
                        }
                        break;

                    case "category":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Category Name must be needed";
                        }
                        break;

                    // case "qty":
                    //     if (!value || String(value).trim().length < 1) {
                    //         detailErrors[index][field] = "Quantity must be needed";
                    //     }
                    //     break;

                    case "total":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Total must be needed";
                        } 
                        break;
                }
        };

        const getDetailError = (index, field) => {
            return detailErrors[index] && detailErrors[index][field]
            ? [detailErrors[index][field]]
            : [];
        };

        const validateAllDetails = () => {
            let isValid = true;
            cart.value.forEach((detail, index) => {
                validateDetailField(index, "product_id", detail.product_id);
                validateDetailField(index, "category", detail.category);
                validateDetailField(index, "qty", detail.qty);
                validateDetailField(index, "total", detail.total);

                if (detailErrors[index]) {
                Object.values(detailErrors[index]).forEach((error) => {
                    if (error) isValid = false;
                });
                }
            });

            return isValid;
        };

        const submitForm = (status) => {                                                                                                                                                                                                                                                                 
            if (!validateAllDetails()) {
                toast.error("Please fix detail validation errors before submitting");
                return;
            }

            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.sub_total = proxy.subTotal;

            values.discount_amount = proxy.discountAmount;
            
            values.tax_amount = proxy.taxAmount;
            values.tax_type = proxy.taxType;

            values.vat_amount = proxy.vatAmount;
            values.vat_type = proxy.vatType;

            values.total = proxy.grandTotal;

            values.cart = cart.value;
            values.receive_date = formattedDate(receive_date.value.value);
            values.cheque_date = formattedDate(cheque_date.value.value);
            values.paid = paid.value.value;
            values.previous_due = previous_due.value.value;
            values.due = due.value.value;
            values.next_payment_date = formattedDate(next_payment_date.value.value);
            values.next_payment_amount = next_payment_amount.value.value;
            store.dispatch("saveUpdateSaleOrder", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-order-record" });
                    }, 2000);
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;
                        const messages = Object.values(errors).flat().join('\n');
                        toast.error(messages);
                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }
                });
        });

        return {
            submitForm,
            submit,
            product_id,
            payment_mode,
            commodity,
            shipper_company_name,
            shipper_phone,
            remarks,

            rate_id,
            currency_rate,

            payment_method,
            payment_acc_account_head_id,
            cheque_no,
            cheque_date,
            issuing_bank_name,
            issuing_branch_name,
            issuing_bank_account_no,

            receive_no,
            chalan_no,
            receive_date,
            shop_name,
            buyer_phone,
            shipment_mode,

            from_port_id,
            to_port_id,
            sales_by,

            discount_value,
            discount_method,
            discount_amount,
            tax_amount,
            tax_value,
            tax_method,
            tax_type,
            vat_amount,
            vat_value,
            vat_method,
            vat_type,
            next_payment_date,
            next_payment_amount,
            status,
            total,
            paid,
            previous_due,
            due, 
            cart,
            saleOrder_by,
            saleOrder_by_mobile,
            saleOrder_by_email,
            errorMessages,
            employee_id,
            customer_id,
            supplier_id,
            sale_order_master_id,
            addDetailRow,
            removeDetailRow,
            buttonText,
            loading,
            detailErrors,
            validateDetailField,
            getDetailError,
            validateAllDetails,
            search,
            productExists,
            calculateRow,
            onSearch,
            createNewProduct,
        };
    },

    mounted() {
        this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.saleOrder_by.value.value = user.full_name;
        this.saleOrder_by_mobile.value.value = user.mobile;
        this.saleOrder_by_email.value.value = user.email;
        this.commodity.value.value = "";
        this.shipper_company_name.value.value = "";
        this.shipper_phone.value.value = "";
        const id = this.$route.query.id;

        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                    .dispatch("getSaleOrderById", id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let saleOrder = data;
                        this.sale_order_master_id.value.value = saleOrder.id;
                        this.receive_date.value.value = saleOrder.receive_date ? new Date(saleOrder.receive_date) : new Date();

                        this.receive_no.value.value = saleOrder.receive_no;
                        this.chalan_no.value.value = saleOrder.chalan_no;
                        this.customer_id.value.value = saleOrder.customer_id;
                        this.shop_name.value.value = saleOrder.shop_name;
                        this.buyer_phone.value.value = saleOrder.buyer_phone;
                        this.shipment_mode.value.value = saleOrder.shipment_mode;
                        this.payment_mode.value.value = saleOrder.payment_mode;

                        this.from_port_id.value.value = saleOrder.from_port_id;
                        this.to_port_id.value.value = saleOrder.to_port_id;

                        this.commodity.value.value = saleOrder.commodity;
                        this.supplier_id.value.value = saleOrder.supplier_id;
                        this.shipper_company_name.value.value = saleOrder.shipper_company_name;
                        this.shipper_phone.value.value = saleOrder.shipper_phone;

                        this.payment_method.value.value = saleOrder.payment_method;
                        // this.payment_acc_account_head_id.value.value = saleOrder.payment_acc_account_head_id;
                        setTimeout(() => {
                            this.payment_acc_account_head_id.value.value = saleOrder.voucher_master?.payment_acc_account_head_id
                        }, 1000);
                        this.cheque_no.value.value = saleOrder.voucher_master?.cheque_no
                        this.cheque_date.value.value = saleOrder.voucher_master?.cheque_date
                        this.issuing_bank_name.value.value = saleOrder.voucher_master?.issuing_bank_name
                        this.issuing_branch_name.value.value = saleOrder.voucher_master?.issuing_branch_name
                        this.issuing_bank_account_no.value.value = saleOrder.voucher_master?.issuing_bank_account_no

                        // this.bankName.value.value = saleOrder.bank_name;
                        // this.accountNo.value.value = saleOrder.account_no;
                        // this.chequeNo.value.value = saleOrder.cheque_no;
                        // this.cheque_date.value.value = saleOrder.cheque_date;

                        this.discount_method.value.value = saleOrder.discount_method;
                        this.discount_value.value.value = this.discount_method.value.value == 'percent'? saleOrder.discount_value + '%' : saleOrder.discount_value;

                        this.tax_method.value.value = saleOrder.tax_method;
                        this.tax_value.value.value = this.tax_method.value.value == 'percent'? saleOrder.tax_value + '%' : saleOrder.tax_value;
                        this.taxType = saleOrder.tax_type;

                        this.vat_method.value.value = saleOrder.vat_method;
                        this.vat_value.value.value = this.vat_method.value.value == 'percent'? saleOrder.vat_value + '%' : saleOrder.vat_value;
                        this.vatType = saleOrder.vat_type;

                        this.rate_id.value.value = saleOrder.rate_id;
                        this.currency_rate.value.value = saleOrder.currency_rate;

                        this.paid.value.value = saleOrder.paid;
                        this.previous_due.value.value = saleOrder.previous_due;
                        this.due.value.value = saleOrder.due;

                        this.sales_by.value.value = saleOrder.sales_by;

                        this.next_payment_date.value.value = saleOrder.next_payment_date;
                        this.next_payment_amount.value.value = saleOrder.next_payment_amount;

                        this.status.value.value = saleOrder.status;
                        this.product_id.value.value = null;
                        // this.onCustomerChange(this.customer_id.value.value);
                        //  if(saleOrder.details.length > 0) {
                            this.cart = [];
                        // }

                        // Insert items one by one
                        (saleOrder.details || []).forEach((item) => {
                            this.cart.push({
                                product_id: item.product_id,
                                category: item.category || "",
                                calc_type: item.calc_type || "",
                                bag: item.bag || "",
                                qty: item.qty,
                                cbm_meas: item.cbm_meas || "",
                                cbm: item.cbm || "",
                                rate: item.rate,
                                height: item.height || "",
                                length: item.length || "",
                                width: item.width || "",
                                total: item.total,
                                remarks: item.remarks,
                            });
                        });
                        this.remarks.value.value = saleOrder.remarks ? saleOrder.remarks : "";
                        this.$store.commit("UNSET_LOADING");
                    })
                    .catch((error) => {
                        this.$store.commit("UNSET_LOADING");
                        console.error("Failed to fetch rfq:", error);
                    });
            });
        } else {
            this.sale_order_master_id.value.value = "";
            this.receive_date.value.value = new Date();
            this.paid.value.value = 0;
            this.previous_due.value.value = 0;
            this.due.value.value = 0;
            this.next_payment_amount.value.value = 0;
            this.isEntryMode = true;
        }
    },
};
</script>
